<a [href]="url" class="signup-link" title="{{ action }} with Google">
  <img src="/assets/images/google_logo.svg" alt="{{ action }} with Google" />
</a>
